import React from 'react';
import PropTypes from 'prop-types';

const PageContainer = ({ classes, children }) => (
  <section className={`${classes}`}>
    {children}
  </section>
);

PageContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  classes: PropTypes.string,
};

export default PageContainer;



// WEBPACK FOOTER //
// ./library/app/components/Global/Containers/PageContainer.js